/**
 * Escapes characters with a special meaning in regular expressions, so e.g. "Dr." matches the dot literally
 * instead of any character.
 */
function escapeRegExp(text: string) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getTerms(query: string) {
    return query
        .split(/[\s,]+/)
        .filter(Boolean)
        .map(escapeRegExp);
}

/**
 * Whether `text` contains every whitespace- or comma-separated term of `query` (case-insensitive),
 * matching the same way `splitByMatches()` highlights.
 */
export function matchesQuery(text: string, query: string) {
    return getTerms(query).every((term) => new RegExp(term, 'iu').test(text));
}

/**
 * Splits `text` into the parts matching any whitespace- or comma-separated term of `query` (case-insensitive)
 * and the parts in between, e.g. for highlighting search matches.
 */
export function splitByMatches(text: string, query: string): { text: string; isMatch: boolean }[] {
    // Longest first, so "Williams" is matched as a whole before "Willi"
    const terms = getTerms(query).sort((a, b) => b.length - a.length);

    if (terms.length === 0) {
        return [{ text, isMatch: false }];
    }

    // With a capturing group, split() puts the matches at the odd indices
    return text
        .split(new RegExp(`(${terms.join('|')})`, 'iu'))
        .map((part, index) => ({ text: part, isMatch: index % 2 === 1 }))
        .filter((part) => part.text !== '');
}
